import React from 'react';
import './styles/loading.css';

export default function Loading () {
  return (
    <div class="loadingio-spinner-chunk-h63b851wqct">
      <div className="ldio-dlikjljmolt">
        <div><div><div /><div /><div /><div /></div></div>
      </div>
    </div>
  );
}
